import { AddressInfo } from '@frame/ui-components/address/types'

export enum PayUnit {
  ANNUALLY = 'annually',
  HOURLY = 'hourly',
  OTHER = 'other',
}

export type FormValues = {
  start_date: string
  end_date: string
  current_job?: boolean
  job_title: string
  employer_name?: string
  employer_address: AddressInfo
  does_not_have_employer_address: boolean
  pay_unit: PayUnit
  current_gross_base_pay: string
  hours_worked_per_week: string
}
